module.exports = __webpack_public_path__ + "img/09医学院.58522e43.png";